import React, { useState } from 'react';
import { Text, Icons, Box, styled, Button } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';
import { HeaderMenu } from '../Header/HeaderContents/HeaderSearch/HeaderMenu/HeaderMenu';

export interface MyAccountHeaderProps {
  /** Indicates if the current user is an unlimited user */
  isUnlimited?: boolean;
  customTextStyling?: object;
  showDescription?: boolean;
}
const StyledHeader = styled(Box)({
  display: 'flex',
  cursor: 'pointer',
});

const MyAccountText = (
  <Text variant="h1" sx={{ display: 'flex', alignItems: 'center' }}>
    <Icons.Person color="primary" sx={{ marginRight: 1 }} fontSize="large" /> My
    Account
  </Text>
);
/**
 * This component shows the header of the My Account page.
 * It shows the title, a description and a message if the user is an unlimited user.
 */
export function MyAccountHeader({
  isUnlimited = false,
  customTextStyling,
  showDescription = true,
}: MyAccountHeaderProps) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(menuAnchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };
  const { isTablet } = useScreenSize();
  return (
    <div>
      {!isTablet ? (
        MyAccountText
      ) : (
        <>
          <StyledHeader onClick={handleMenuClick}>
            {MyAccountText}
            <Button color="success" onClick={handleMenuClick}>
              {open ? <Icons.ExpandLess /> : <Icons.ExpandMore />}
            </Button>
          </StyledHeader>
          <HeaderMenu
            anchorEl={menuAnchorEl}
            open={open}
            handleClose={handleCloseMenu}
          />
        </>
      )}
      {showDescription && (
        <>
          {isUnlimited && (
            <Text variant="body1" mb={1} sx={customTextStyling}>
              You have{' '}
              <Text
                variant="h4"
                sx={{ display: 'inline', ...customTextStyling }}
                component="span"
              >
                access
              </Text>{' '}
              to all report types and features
            </Text>
          )}

          <Text variant="body2" mb={1}>
            Be sure to take full advantage of all the features that are included
          </Text>
        </>
      )}
    </div>
  );
}
